module.exports = __webpack_public_path__ + "static/img/zp_zz_hs.84a7d81.png";


//////////////////
// WEBPACK FOOTER
// ./static/runtime/images/magic/award/zp_zz_hs.png
// module id = iNxw
// module chunks = 1